export default __webpack_public_path__ + "static/media/default_icon.e151e0c4.png";